export const PlacementOptions = [
  'bottom-right',
  'top-right',
  'bottom-left',
  'top-left',
  'bottom-center',
];
